import { lazy } from 'react';
import OnlyEnterprise from '@/components/only-enterprise';

import type { RouteProps } from 'react-router-dom';

const PersonalCenterLayout = lazy(() => import('.'));
const UserInfo = lazy(() => import('./user-info'));
const OrderDetail = lazy(() => import('./order-detail'));
const OrderList = lazy(() => import('./order-list'));
const MyContract = lazy(() => import('./my-contract'));
const UploadInquiry = lazy(() => import('./upload-inquiry')); // 上传询价单
const InquiryListist = lazy(() => import('./inquiry-list')); // 询价单列表
const MyFavorite = lazy(() => import('./my-favorite'));
const MyHistory = lazy(() => import('./my-history'));
const UserAddress = lazy(() => import('./user-address'));
const Billing = lazy(() => import('./billing'));
const AccountAdmin = lazy(() => import('./account-admin'));
const MailBox = lazy(() => import('./message/index'));
const OrderImport = lazy(() => import('./order-import/index'));
const OrderExport = lazy(() => import('./order-export/index'));
const DetailExport = lazy(() => import('./detail-export/index'));
const SubAdminEditor = lazy(() => import('./account-admin/editor'));
const Introduction = lazy(() => import('./product-introduction'));
const AddInfo = lazy(() => import('./addInfo'));
const OrderDetailReport = lazy(() => import('./orderDetail-report'));
const SdiShipment = lazy(() => import('./sdi-shipment'));
const SdiOrder = lazy(() => import('./sdi-order'));
const SdiOrderJs = lazy(() => import('./sdi-order-js'));
const SdiUnshipment = lazy(() => import('./sdi-unshipment'));
const CustomerSalesDetails = lazy(() => import('./customerSales-details'));
const UnshippedDetails = lazy(() => import('./unshipped-details'));
// const ZHOInquiry = lazy(() => import('./ZHO-inquiry'));

export const routeConfig: (RouteProps & { subChildren?: RouteProps[] })[] = [
  {
    path: '/personal-center',
    element: <PersonalCenterLayout />,
    subChildren: [
      { path: '/personal-center/user-info', element: <UserInfo /> },
      { path: '/personal-center/order-detail/:id', element: <OrderDetail /> },
      { path: '/personal-center/order-list', element: <OrderList /> },
      { path: '/personal-center/orderDetail-report', element: <OrderDetailReport /> },
      { path: '/personal-center/sdi-shipment', element: <SdiShipment /> },
      { path: '/personal-center/sdi-order', element: <SdiOrder /> },
      { path: '/personal-center/sdi-order-js', element: <SdiOrderJs /> },
      { path: '/personal-center/sdi-unshipment', element: <SdiUnshipment /> },
      { path: '/personal-center/customerSales-details', element: <CustomerSalesDetails /> },
      { path: '/personal-center/unshipped-details', element: <UnshippedDetails /> },
      // { path: '/personal-center/ZHO-inquiry', element: <ZHOInquiry /> },
      { path: '/personal-center/my-contract', element: <MyContract /> },
      { path: '/personal-center/my-favorite', element: <MyFavorite /> },
      { path: '/personal-center/my-history', element: <MyHistory /> },
      { path: '/personal-center/upload-inquiry', element: <UploadInquiry /> },
      { path: '/personal-center/inquiry-list', element: <InquiryListist /> },
      {
        path: '/personal-center/user-address',
        element: <UserAddress />,
      },
      {
        path: '/personal-center/billing',
        element: <Billing />,
      },
      {
        path: '/personal-center/account-admin',
        element: (
          <OnlyEnterprise>
            <AccountAdmin />
          </OnlyEnterprise>
        ),
      },
      {
        path: '/personal-center/account-admin/:id',
        element: (
          <OnlyEnterprise>
            <SubAdminEditor />
          </OnlyEnterprise>
        ),
      },
      {
        path: '/personal-center/product-introduction',
        element: <Introduction />,
      },
      {
        path: '/personal-center/mail-box',
        element: <MailBox />,
      },
      {
        path: '/personal-center/order-import',
        element: <OrderImport />,
      },
      {
        path: '/personal-center/order-export',
        element: <OrderExport />,
      },
      {
        path: '/personal-center/detail-export',
        element: <DetailExport />,
      },
      {
        path: '/personal-center/addInfo',
        element: <AddInfo />,
      },
    ],
  },
];
